import React, { Fragment } from 'react';

import withAuthServerSideProps from '@/libs/auth';
import { PageLayout, PagePath } from '@/layouts/shared';
import { GetServerSidePropsContext } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import MetaTag from '@/components/ui/MetaTag';
import { Icon, Image, LogoWhite, CopyIcon, Button, Link } from '@/components';
import CopyToClipboard from 'react-copy-to-clipboard';
import toast from 'react-hot-toast';
const ReferralPage = ({ code }: { code: string }) => {
  const webUrl = process.env.APP_URL;
  return (
    <Fragment>
      <MetaTag title="Giới thiệu An Thư" description="Giới thiệu An Thư" />
      <div className="tw-w-screen tw-min-h-screen tw-h-max tw-bg-no-repeat">
        <div
          className="tw-w-full tw-h-full tw-min-h-screen tw-py-10 md:tw-py-16 tw-bg-no-repeat"
          style={{
            backgroundImage: 'url(/bg-referral.jpg)',
            backgroundSize: '100% 100%',
          }}
        >
          <div className="tw-flex tw-justify-center tw-items-center">
            <LogoWhite />
          </div>
          <div className="tw-w-11/12 tw-max-w-5xl lg:tw-w-4/5 xl:tw-w-7/12 tw-bg-white tw-mt-12 tw-mx-auto tw-rounded-xl tw-px-4 tw-py-6 md:tw-py-10 md:tw-px-9 tw-flex md:tw-space-x-6 tw-items-center tw-flex-col md:tw-flex-row">
            <div className="">
              <Image
                src="/gift-referral.png"
                alt="gift image"
                className="tw-w-32 tw-h-32 md:tw-w-52 md:tw-h-52 lg:tw-w-60 lg:tw-h-60"
              />
            </div>
            {code && (
              <div className="tw-flex-none md:tw-flex-1">
                <div className="tw-text-center md:tw-text-left tw-text-base md:tw-text-lg lg:tw-text-xl tw-text-primary-main tw-font-semibold">
                  Bạn đã nhận được lời mời mua sắm ở An Thư. Vui lòng hoàn thành các bước sau để nhận ưu đãi hấp dẫn:
                </div>
                <div className="tw-mt-10 tw-space-y-6 md:tw-space-y-8">
                  <div className="tw-flex tw-place-items-center">
                    <span className="tw-w-6 tw-h-6 tw-text-white tw-bg-primary-main tw-flex tw-justify-center tw-items-center tw-rounded-full tw-mr-4 tw-text-13">
                      1.
                    </span>
                    <span className="tw-text-sm md:tw-text-base">
                      Tải ứng dụng AnThu hoặc truy cập{' '}
                      <Link url={webUrl || 'http://anthu.vn'}>{webUrl || 'http://anthu.vn'}</Link>
                    </span>
                  </div>
                  <div className="tw-flex tw-place-items-center">
                    <span className="tw-w-6 tw-h-6 tw-text-white tw-bg-primary-main tw-flex tw-justify-center tw-items-center tw-rounded-full tw-mr-4 tw-text-13">
                      2.
                    </span>
                    <span className="tw-text-sm md:tw-text-base">Tạo tài khoản</span>
                  </div>
                  <div className="tw-flex md:tw-flex-row tw-flex-col md:tw-items-center">
                    <div className="tw-flex tw-items-center tw-justify-start">
                      <span className="tw-w-6 tw-h-6 tw-text-white tw-bg-primary-main tw-flex tw-justify-center tw-items-center tw-rounded-full tw-mr-4 tw-text-13">
                        3.
                      </span>
                      <span className="tw-mr-3">Sao chép và dán mã giới thiệu</span>
                    </div>

                    <div className="tw-py-3 tw-px-4 tw-border tw-border-primary-main tw-rounded-md tw-text-base tw-font-light tw-leading-6 tw-flex-1 tw-flex tw-justify-between tw-w-full tw-mt-2 md:tw-mt-0">
                      <span>{code}</span>
                      <CopyToClipboard text={code} onCopy={() => toast.success('Sao chép thành công')}>
                        <Icon className=" tw-text-primary-main" icon={<CopyIcon />} />
                      </CopyToClipboard>
                    </div>
                  </div>
                  <div className="tw-flex tw-place-items-center">
                    <span className="tw-w-6 tw-h-6 tw-text-white tw-bg-primary-main tw-flex tw-justify-center tw-items-center tw-rounded-full tw-mr-4 tw-text-13">
                      4.
                    </span>
                    <span className="tw-mr-3">Mua sắm thành công và nhận ưu đãi</span>
                  </div>
                  <div className="tw-flex md:tw-flex-row tw-flex-col tw-space-y-4 md:tw-space-y-0 md:tw-space-x-6 tw-text-sm lg:tw-text-base">
                    <Link
                      className="tw-py-2 md:tw-w-1/2 tw-text-center tw-rounded-5 tw-uppercase !tw-text-white tw-bg-primary-main active:tw-text-white"
                      url={{
                        pathname: PagePath.SignUpPage,
                        query: {
                          code: code,
                        },
                      }}
                    >
                      Bắt đầu đăng ký
                    </Link>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export const getServerSideProps = withAuthServerSideProps(
  async ({ locale, query }: GetServerSidePropsContext) => {
    const code = query.code || '';
    return {
      props: {
        code,
        layout: PageLayout.Basic,
        ...(await serverSideTranslations(locale as string, ['layout'])),
      },
    };
  },
  { isAntiAuth: false, isPublic: true }
);

export default ReferralPage;
